export default __webpack_public_path__ + "static/media/pokemon.007a71aa.png";